import React from 'react'
import { Modal } from 'antd'
import styles from './qrcode-modal.module.less'

interface QRCodeModalProps {
  slogan: string;
  onGetQrCode: () => Promise<{ qrCodeUrl: string }>;
  visible: boolean;
  onClose: () => void;
}

const QRCodeModal = (props: QRCodeModalProps) => {
  const { slogan, visible = false, onClose } = props
  return (
    <Modal
      visible={visible}
      footer={null}
      maskClosable={false}
      centered={true}
      width={288}
      wrapClassName={styles.modal}
      onCancel={onClose}
      // afterClose={resetState}
    >
      <div className={styles.qrcodeBody}>
        <div className={styles.qrcodeTitle}>扫一扫下载网络门店APP</div>
        <div className={styles.qrcodeSlogan}>{slogan}</div>
        <div className={styles.qrcodeDrawer}>
          <img src='https://pic3.58cdn.com.cn/nowater/frs/n_v324dd6900b13e4f06b12249ab0d5228ac.png' alt="二维码" width={168} height={168} />
        </div>
      </div>
    </Modal>
  )
}

export { QRCodeModal }
